module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.4312f1f.ttf";